import { useConfiguration } from '~/context/common/StaticContext';
import { hasVaultWhyBuyData } from '~/utilities/vdp/whyBuyNarrative';
import useGetVaultWhyBuyNarrative from './useGetVaultWhyBuyNarrative';

export default function useHasVaultWhyBuyData(): boolean {
  const { useVaultWhyBuy = false } = useConfiguration();
  const { narrativeContent } = useGetVaultWhyBuyNarrative();

  return useVaultWhyBuy && hasVaultWhyBuyData(narrativeContent);
}
